/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import {
  menuController,
} from '@ionic/vue';
import {
  store,
} from '../store/store';
import {
  STORE_NAMESPACE,
} from '../store/modules/store.namespace';
import {
  MENU_ACTIONS_ENUM,
} from '../store/modules/menu/menu.enum';
import d3 from '../globalexports/d3.export';

const menuService = () => {
  const content = {};
  content.menuOpened = () => {
    d3.select('#d3tipcontent').style('opacity', '0');
    d3.select('#trendLineTrackareaRoute').style('pointer-events', 'none');
    d3.select('#trendLineTrackareaMeteo').style('pointer-events', 'none');
  };
  content.menuClosed = () => {
    d3.select('#trendLineTrackareaRoute').style('pointer-events', 'all');
    d3.select('#trendLineTrackareaMeteo').style('pointer-events', 'all');
  };
  content.closeMenu = () => {
    menuController.close();
  };
  content.toggleMenu = () => {
    menuController.toggle();
  };
  content.disableEnableMenuSwipe = (status) => {
    if (status) {
      store.dispatch(
        `${STORE_NAMESPACE.MENU}/${MENU_ACTIONS_ENUM.ENABLE_SWIPE_GESTURE}`,
      );
    } else {
      store.dispatch(
        `${STORE_NAMESPACE.MENU}/${MENU_ACTIONS_ENUM.DISABLE_SWIPE_GESTURE}`,
      );
    }
  };
  return content;
};
export default menuService();
